module.exports = __webpack_public_path__ + "img/640851971.702da9d6.jpg";